import Model from './BaseModel';

export default class SportClassification extends Model {
	resourceName() {
		return 'sport_classifications';
	}

	fields() {
		return ['classification', 'market_group_set_id', 'sport'];
	}

	updateMarketGroupSet(data) {
		return this.makePersistRequest({
			url: `${this.baseUrl()}/sports/${this.sport.id}/classifications/${this.classification.id}`,
			method: 'PATCH',
			data
		});
	}
}
